import React from "react";
import "./Home.css";
import HoneycombBanner from "./HoneycombBanner";
import About from "./About";
import Experience from "./Experience";
import Skills from "./Skills";
import Projects from "./Projects";
import Contact from "./Contact";

function Home() {
  return (
    <main className="page-main">
      <div id="top" />
      <div className="hero-banner">
        <HoneycombBanner />
        <div className="hero-overlay">
          <div className="hero-status">
            <span className="hero-status-dot" aria-hidden="true" />
            Open to opportunities
          </div>

          {/* <div className="hero-status">
            <span className="hero-status-dot" aria-hidden="true" />
            Rails · Vue · Nuxt
          </div> */}

          <div className="hero-center">
            <div className="hero-emblem" aria-hidden="true">
              <div className="hero-emblem-ring" />
              <div className="hero-emblem-core">
                <span>JS</span>
              </div>
            </div>
            <h1 className="hero-name">Jas Sabharwal</h1>
            <p className="hero-tagline">Full-stack developer · Southern Ontario area</p>
          </div>

          <div className="hero-dock">
            <a href="#work" className="hero-dock-link hero-dock-link--primary">
              View work
            </a>
            <a href="#about" className="hero-dock-link">
              About
            </a>
            <a href="#contact" className="hero-dock-link">
              Contact
            </a>
            <a href="#about" className="hero-scroll-cue" aria-label="Scroll to about">
              <span className="hero-scroll-mouse">
                <span className="hero-scroll-wheel" />
              </span>
            </a>
          </div>
        </div>
      </div>

      <About />
      <Experience />
      <Skills />
      <Projects />
      <Contact />
    </main>
  );
}

export default Home;
